<toolbar-halls *renderIf="{mediaSelector:'gt-lg'}"  class="hidden lg:block sticky top-[120px]"></toolbar-halls>
<events-archive-header *renderIf="{mediaSelector:'gt-md'}" class="w-full hidden md:block"></events-archive-header>
<events-archive-headerResponsive *renderIf="{mediaSelector:'lt-md'}" class="w-full md:hidden"></events-archive-headerResponsive>


<!-- CONTENT -->
<content class="container py-12">
<!--   <div class="filter-container flex flex-col justify-center my-5 sm:flex-row sm:my-5">
    <form [formGroup]="searchForm" class="form" autocomplete="off">
      <mat-form-field appearance="outline">
        <mat-select formControlName="fieldOfRelevance" i18n-placeholder placeholder="All fields">
          @for (field of fields; track $index) {
            <mat-option [value]="field.value">{{field.label}}</mat-option>
          }
        </mat-select>
      </mat-form-field>

    </form>
    <button class="!h-14 mb-5 md:mb-0 md:mr-5" (click)="search()" mat-raised-button i18n>Search</button>
    <button class="!h-14" [style.display]="isVisible ? 'block': 'none'"  (click)="clear()" mat-raised-button i18n>Clear filters</button>
  </div> -->

  <paged-virtual-scroller
    [scrollWithMainScrollbar]="true"
    [itemTpl]="eventScrollerTpl"
    [pageSize]="6"
    [scaleUpOnRender]="false"
    [itemHeight]="(265 + 25)"
    [itemWidth]="(400 + 25)"
    seoFriendly="offset-cursor"
    [itemsQuery]="eventsQuery"
    sender="archive">
  </paged-virtual-scroller>

  <ng-template let-item #eventScrollerTpl>
    <event-block
      class="w-[290px] h-[192px] md:w-[400px] md:h-[265px]"
      #eventBlock
      [portalEvent]="item"
      [imageSizes]="[{ w: 400, h: 225, resizeMode: 'fill' }]">
      <card-edit-bar
        *renderIf="{roles:[UserRolesEnum.admin]}"
        [show]="eventBlock.hovered"
        (edit)="editPortalEvent(item)"
        (softDelete)="softDeletePortalEvent(item)"
        i18n-editTooltip editTooltip="edit event"
        i18n-deleteTooltip deleteTooltip="delete event"
        i18n-deleteMsg deleteMsg="Do you really want to delete this event?">
      </card-edit-bar>
    </event-block>
  </ng-template>
</content>
@defer(on timer(5s)) {
  <exp-footer class="text-orange"></exp-footer>
}